import MYOBConfigure from './MYOBConfigure';

export default MYOBConfigure;
